
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Progress } from "antd";


import "./usage.scss";
class Usage extends Component{
    constructor(props) {
        super(props)

        let usageList=[
            {
                name:'cloud to cloud',
                storage: '10 TB',
                percentage: 63,
            },
            {
                name:'aws to wasabi',
                storage: '20 TB',
                percentage: 80,
            },

        ];
        this.state = {
            usage: usageList,
        }

    }
    render(){
        const usageReport = this.state.usage.map((u,index)=>{
            return(
                <div className="usage-report-wrapper" key = {index}>
                    <div className="usage-report-header">
                        <p>{u.name}</p>
                        <p>{u.storage}</p>
                    </div>
                    <div className="usage-percentage">
                        <Progress percent={u.percentage} size="small" status="active" />
                    </div>
                </div>
            )
        })
        return(
            <div className="usage-wrapper">
                <div className="header">
                    <h3>Service Usage</h3>
                </div>
                <div className="content">
                    {usageReport}
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(Usage)
  );